export const GET_SOCIAL_ORGANIZATION_FEEDBACKS = 'GET_SOCIAL_ORGANIZATION_FEEDBACKS';
export const GET_SOCIAL_ORGANIZATION_FEEDBACKS_SUCCESS = 'GET_SOCIAL_ORGANIZATION_FEEDBACKS_SUCCESS';
export const GET_SOCIAL_ORGANIZATION_FEEDBACKS_FAILED = 'GET_SOCIAL_ORGANIZATION_FEEDBACKS_FAILED';

export const GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL = 'GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL';
export const GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_SUCCESS = 'GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_SUCCESS';
export const GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_FAILED = 'GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_FAILED';

export const UPDATE_SOCIAL_ORGANIZATION_FEEDBACK = 'UPDATE_SOCIAL_ORGANIZATION_FEEDBACK';
export const UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS = 'UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS';
export const UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED = 'UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED';

export const RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK = 'RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK';
export const RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS = 'RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS';
export const RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED = 'RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED';

export const REJECT_SOCIAL_ORGANIZATION_FEEDBACK = 'REJECT_SOCIAL_ORGANIZATION_FEEDBACK';
export const REJECT_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS = 'REJECT_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS';
export const REJECT_SOCIAL_ORGANIZATION_FEEDBACK_FAILED = 'REJECT_SOCIAL_ORGANIZATION_FEEDBACK_FAILED';

export const CLEAR_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL = 'CLEAR_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL';
